import { useSelector } from 'react-redux';
import { replaceDomainForCacheKey, useErrorOnNotOkFetchye } from '@americanexpress/fetchye-amex';
import { getHomepageOneCmsUrl } from '../selectors/getOneCmsJsonSelectors';
import { MODULE_NAME } from '../constants/modules';

export const oneCmsReporting = ({ key, error }) => ({
  moduleID: MODULE_NAME,
  component: 'useOneCmsFetchye',
  fetch: {
    url: key,
    status: error?.status,
  },
});

export const useOneCms = () => {
  const url = useSelector(getHomepageOneCmsUrl);

  return useErrorOnNotOkFetchye(url, {
    mapKeyToCacheKey: replaceDomainForCacheKey('oneCMS'),
  }, oneCmsReporting);
};

export const useDataFromOneCms = (key) => {
  const { data } = useOneCms();
  return key?.split('.')?.reduce((remainingObj, nextKey) => remainingObj?.[nextKey], data?.body ?? {});
};
